import React from 'react';
import styles from './Main.module.scss';
import Banner from './Banner/Banner';
import About from './About/About';
import Portfolio from './Portfolio/Portfolio';
import Contact from './Contact/Contact';
const Main = () => {
    return (
        <main id={styles.main}>
            <Banner />
            <About />
            <Portfolio />
            <Contact />
        </main>
    );
}

export default Main;
